import { useState, useEffect } from "react";

const navItems = ["Home", "About", "Products", "Features", "Contact"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo("home")}>
          <img
            src="https://public.readdy.ai/ai/img_res/0d2f963b-8ae8-4acd-826c-58151275469e.png"
            alt="GRUNDAL d.o.o. Logo"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`font-bold text-lg tracking-wide transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            GRUNDAL d.o.o.
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap hover:opacity-70 ${
                scrolled ? "text-gray-700" : "text-white/90"
              }`}
            >
              {item}
            </button>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 transition-colors ${scrolled ? "bg-gray-900" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-colors ${scrolled ? "bg-gray-900" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-colors ${scrolled ? "bg-gray-900" : "bg-white"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className="text-gray-700 text-sm font-medium text-left cursor-pointer whitespace-nowrap hover:text-gray-900"
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
